export const RESOURCE_TYPE_GENERAL = 'RESOURCE_TYPE_GENERAL';
export const RESOURCE_TYPE_STUDENT = 'RESOURCE_TYPE_STUDENT';
export const RESOURCE_TYPE_VOLUNTEER = 'RESOURCE_TYPE_VOLUNTEER';
